var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23, _g24, _g25, _g26, _g27, _g28, _g29, _g30, _g31, _g32, _g33, _g34, _g35, _g36, _g37, _g38, _g39, _g40, _g41, _g42, _g43, _g44, _g45, _g46, _g47, _g48, _g49, _g50, _g51;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedAcccount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 32 32",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grid",
    display: "none"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "account"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Add_account"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "remove_account"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "block_account"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "search_account"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "lock_account"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "love"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "edit_account"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "sound"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "graduation"
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "target"
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "favorite"
  })), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "security"
  })), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "delete_account"
  })), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "unlock_account"
  })), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    id: "setting"
  })), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    id: "public_account"
  })), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    id: "chat"
  })), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    id: "verified_account"
  })), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    id: "group"
  })), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    id: "bookmark"
  })), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    id: "database"
  })), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    id: "cloud"
  })), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    id: "link"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m11.289 18.3h4.32c2.099 0 4.061.827 5.525 2.329.348.355.916.363 1.273.016.355-.347.362-.917.016-1.272-1.186-1.216-2.639-2.064-4.227-2.51 2.319-1.542 3.852-4.176 3.852-7.163 0-4.741-3.857-8.599-8.599-8.599s-8.6 3.857-8.6 8.599c0 2.99 1.536 5.625 3.858 7.166-3.993 1.128-6.93 4.796-6.93 9.145v1.23c0 1.353.956 2.516 2.27 2.764 3.068.595 6.231.896 9.401.896.179 0 .357 0 .534-.011.496-.031.874-.458.844-.954-.03-.497-.466-.871-.953-.843-.125.008-.25.008-.375.008-3.058.038-6.136-.287-9.113-.864-.468-.088-.807-.507-.807-.996v-1.23c.001-4.253 3.459-7.711 7.711-7.711zm-4.638-8.601c0-3.749 3.05-6.799 6.799-6.799s6.798 3.05 6.798 6.799-3.049 6.799-6.798 6.799-6.799-3.05-6.799-6.799z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m19.055 26.751c0 .497.403.9.9.9h6.008c.497 0 .9-.403.9-.9s-.403-.9-.9-.9h-6.008c-.497 0-.9.403-.9.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m26.068 22.596h-1.582c-.497 0-.9.403-.9.9s.403.9.9.9h1.582c1.298 0 2.353 1.055 2.353 2.353 0 1.297-1.055 2.352-2.353 2.352h-1.582c-.497 0-.9.403-.9.9s.403.9.9.9h1.582c2.29 0 4.153-1.862 4.153-4.152s-1.863-4.153-4.153-4.153z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m21.433 29.1h-1.583c-1.297 0-2.352-1.055-2.352-2.352s1.055-2.353 2.352-2.353h1.583c.497 0 .9-.403.9-.9s-.403-.9-.9-.9h-1.583c-2.289 0-4.152 1.863-4.152 4.152s1.863 4.153 4.152 4.153h1.583c.497 0 .9-.403.9-.9s-.403-.9-.9-.9z"
  }))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    id: "bank_account"
  })), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    id: "change"
  })), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    id: "view"
  })), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    id: "message"
  })), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    id: "location"
  })), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    id: "winner"
  })), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    id: "log_in"
  })), _g33 || (_g33 = /*#__PURE__*/React.createElement("g", {
    id: "log_out"
  })), _g34 || (_g34 = /*#__PURE__*/React.createElement("g", {
    id: "transfer"
  })), _g35 || (_g35 = /*#__PURE__*/React.createElement("g", {
    id: "change_account"
  })), _g36 || (_g36 = /*#__PURE__*/React.createElement("g", {
    id: "navigation"
  })), _g37 || (_g37 = /*#__PURE__*/React.createElement("g", {
    id: "delete_group"
  })), _g38 || (_g38 = /*#__PURE__*/React.createElement("g", {
    id: "join_group"
  })), _g39 || (_g39 = /*#__PURE__*/React.createElement("g", {
    id: "block_group"
  })), _g40 || (_g40 = /*#__PURE__*/React.createElement("g", {
    id: "attachment"
  })), _g41 || (_g41 = /*#__PURE__*/React.createElement("g", {
    id: "download"
  })), _g42 || (_g42 = /*#__PURE__*/React.createElement("g", {
    id: "upload"
  })), _g43 || (_g43 = /*#__PURE__*/React.createElement("g", {
    id: "anonymous"
  })), _g44 || (_g44 = /*#__PURE__*/React.createElement("g", {
    id: "leave_group_1_"
  })), _g45 || (_g45 = /*#__PURE__*/React.createElement("g", {
    id: "chatting"
  })), _g46 || (_g46 = /*#__PURE__*/React.createElement("g", {
    id: "share"
  })), _g47 || (_g47 = /*#__PURE__*/React.createElement("g", {
    id: "at"
  })), _g48 || (_g48 = /*#__PURE__*/React.createElement("g", {
    id: "id_card"
  })), _g49 || (_g49 = /*#__PURE__*/React.createElement("g", {
    id: "rotate"
  })), _g50 || (_g50 = /*#__PURE__*/React.createElement("g", {
    id: "audio_1_"
  })), _g51 || (_g51 = /*#__PURE__*/React.createElement("g", {
    id: "avatar"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedAcccount);
export default __webpack_public_path__ + "static/media/linked-acccount.1ab3358029720c5dbb59202eaebd6c0b.svg";
export { ForwardRef as ReactComponent };